import React, { useMemo, useState } from 'react';

import { isBrowser } from '@app/utils';
import { ExperimentsContext } from '@app/experiments';
import ExperimentsAnalytics from './components/ExperimentsAnalytics';

const ExperimentsProvider = ({ children, req }) => {
  const [experiments, setExperiments] = useState(
    (
      req?.appContext?.states?.experiments?.value ??
      (isBrowser ? window?.__STOCKX_EXPERIMENTS__ : req?.experiments)
    )?.experiments,
  );

  const [abVariants] = useState(
    (
      req?.appContext?.states?.experiments?.value ??
      (isBrowser ? window?.__STOCKX_EXPERIMENTS__ : req?.experiments)
    )?.abVariants,
  );

  const context = useMemo(
    () => ({ experiments, setExperiments, abVariants }),
    [experiments, abVariants],
  );

  return (
    <ExperimentsContext.Provider value={context}>
      <ExperimentsAnalytics>{children}</ExperimentsAnalytics>
    </ExperimentsContext.Provider>
  );
};

export default ExperimentsProvider;
